<template>
  <section>
    <!-- 大圖區 -->
    <div
      class="coverings"
      v-for="(photoGroups, groupIndex) in restructedPhotos"
      :key="groupIndex"
    >
      <div v-for="(photo, photoIndex) in photoGroups" :key="photoIndex">
        <div class="coverings__cover" v-if="photoIndex === 0">
          <img
            class="coverings__cover-image"
            style="opacity: 1;"
            :alt="photo.description ? `[打開照片]${photo.description}` : ''"
            :title="photo.description ? `[打開照片]${photo.description}` : ''"
            :src="photo.image_url"
            @click="expandFullPhoto(photo)"
          />
          <!-- 暫時隱藏 lazy-loading -->
          <!-- <img
            class="coverings__cover-image lazyload"
            :alt="photo.description ? photo.description : ''"
            :data-reference="photo.image_url"
            @click="expandFullPhoto(photo)"
          />-->
          <noscript>
            <img
              class="coverings__cover-image"
              style="opacity: 1;"
              :alt="photo.description ? `[打開照片]${photo.description}` : ''"
              :title="photo.description ? `[打開照片]${photo.description}` : ''"
              :src="photo.image_url"
              @click="expandFullPhoto(photo)"
            />
          </noscript>
        </div>

        <!-- 小圖區 -->
        <div class="coverings__photos" v-if="photoIndex > 0">
          <span
            class="coverings__photo"
            v-for="(smallPhoto, smallPhotoIndex) in photo"
            :key="smallPhotoIndex"
          >
            <img
              class="coverings__photo-image"
              style="opacity: 1;"
              :alt="
                smallPhoto.description
                  ? `[打開照片]${smallPhoto.description}`
                  : ''
              "
              :title="`[打開照片]${smallPhoto.description}`"
              :src="smallPhoto.image_url"
              @click="expandFullPhoto(smallPhoto)"
            />
            <!-- 暫時隱藏 lazy-loading -->
            <!-- <img
              class="coverings__photo-image lazyload"
              :alt="smallPhoto.description"
              :data-reference="smallPhoto.image_url"
              @click="expandFullPhoto(smallPhoto)"
            />-->
            <noscript>
              <img
                class="coverings__photo-image"
                style="opacity: 1;"
                :alt="smallPhoto.description"
                :title="
                  smallPhoto.description
                    ? `[打開照片]${smallPhoto.description}`
                    : ''
                "
                :src="smallPhoto.image_url"
                @click="expandFullPhoto(smallPhoto)"
              />
            </noscript>
          </span>
        </div>
      </div>
    </div>

    <Lightbox
      :isPhotoExpanded="isPhotoExpanded"
      :isCurrentPhotoLoaded="isCurrentPhotoLoaded"
      :currentPhoto="currentPhoto"
      @update:currentPhotoLoaded="isCurrentPhotoLoaded = $event"
      @update:photoExpanded="isPhotoExpanded = $event"
      @update:currentPhoto="currentPhoto = $event"
    />
  </section>
</template>

<script>
import Lightbox from '@/components/Lightbox';

export default {
  name: 'PhotoCollection',
  props: {
    displayType: {
      type: String,
      default: '',
    },
    albumPhotos: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isPhotoExpanded: false,
      currentPhoto: {},
      isCurrentPhotoLoaded: null,
    };
  },
  computed: {
    restructedPhotos() {
      return this.restructPhotos(this.albumPhotos);
    },
  },
  methods: {
    restructPhotos(photos) {
      let newArray = [];

      photos.forEach((photo, index) => {
        if (index === 0 || index % 3 === 0) {
          // 第一張 Cover：建立新陣列
          const firstDimensionArr = [photo];
          newArray.push(firstDimensionArr);
        } else if (index === 1 || index % 3 === 1) {
          // 小照片的第一張，建立二維陣列
          const secondDimensionArr = [photo];
          newArray[newArray.length - 1].push(secondDimensionArr);
        } else if (index === 2 || index % 3 === 2) {
          // 小照片的第二張，插入二維陣列的子組合中
          newArray[newArray.length - 1][1].push(photo);
        }
      });

      return newArray;
    },
    expandFullPhoto(photo) {
      // 打開燈箱
      this.isPhotoExpanded = true;

      // 儲存必要資訊
      // TODO 上下張照片，透過 indexInAlbum 屬性切換 albumPhotos 的物件即可。
      this.currentPhoto.image_url = photo.image_url;
      this.currentPhoto.description = photo.description;
      this.currentPhoto.indexInAlbum = this.albumPhotos.findIndex(
        (originPhoto) => {
          return originPhoto.id === photo.id;
        }
      );
    },
  },
  components: {
    Lightbox,
  },
};
</script>

<style lang="scss" scoped>
@keyframes loading {
  from {
    background-position-x: 100%;
  }
  to {
    background-position-x: 0%;
  }
}

.coverings {
  &__cover,
  &__photo {
    position: relative; // for mockup positioning
  }

  &__cover {
    text-align: center;
    margin-bottom: 12px;
  }
  &__cover-image {
    height: 210px;
  }

  &__photo-image {
    height: 135px;
  }

  &__cover-image,
  &__photo-image {
    object-fit: cover;
    object-position: top;
  }

  &__cover-image,
  h4 {
    width: 280px;
  }

  &__photos {
    display: flex;
    justify-content: space-between;
    margin: 0 auto 12px;
    width: auto;
    max-width: 280px;
  }

  &__photo {
    flex-basis: 50%;
    max-width: 150px;
    font-size: 0;

    &:nth-child(1) {
      padding-right: 6px;
    }

    &:nth-child(2) {
      padding-left: 6px;
    }

    &-image {
      width: 100%;
    }
  }

  img {
    opacity: 0;
    transition: opacity 600ms ease-in;
    cursor: pointer;
  }
}

.coverings {
  @include for-desktop {
    margin-left: 10px;

    &:nth-child(3n + 1) {
      margin-left: 0;
    }
  }
}

/* .coverings + .coverings {
  @include for-tablet {
    padding-left: 14px;
  }
} */
</style>
